import { call, put, takeEvery } from 'redux-saga/effects';
import { VERIFY_ACCOUNT_REQUEST } from '../constants/account.constants';
import { verifyAccountRequestSuccess, verifyAccountRequestFailure } from '../actions/account_actions/verify_account.actions';
import { sendVerifyAccountRequest } from '../../requests/account_requests';
import { message_success } from '../../../../components/Message';
import { history } from '../../../../config/history';

function* verifyAccountRequest({ token }) {
    const { result, error } = yield call(sendVerifyAccountRequest, token);
    if (result) {
        yield put(verifyAccountRequestSuccess());
        message_success('Your e-mail address has been successfully verified!');
        history.push('/login');
    } else {
        yield put(verifyAccountRequestFailure(error));
    }
}

export default function* verifyAccountSaga() {
    yield takeEvery(VERIFY_ACCOUNT_REQUEST, verifyAccountRequest);
}



// WEBPACK FOOTER //
// ./src/modules/App/redux/sagas/verify_account.saga.js